export { fetchTypeahead } from 'next-flight-server-reference-proxy-loader?id=7f720a95fac426a8791f40ee93a700101bd4a64384&name=fetchTypeahead!'